module.exports = __webpack_public_path__ + "static/media/usecasesection3.9666d66c.png";